import { useQuery } from '@tanstack/react-query'

import { supabase } from '@/lib/supabase/cliente'
import { mensajeDeError } from '@/lib/supabase/errores'
import type { FilaCronograma } from '@/lib/supabase/tipos-bd'

/**
 * La programación real de las órdenes de trabajo.
 *
 * No es un plan aparte: sale de lo que la Estación 3 ya guardó —colaborador,
 * horas y fechas—, así que el cronograma no se mantiene, se lee.
 */
export function useCronograma() {
  const consulta = useQuery({
    queryKey: ['cronograma'],
    staleTime: 60 * 1000,
    queryFn: async (): Promise<FilaCronograma[]> => {
      const { data, error } = await supabase
        .from('vista_cronograma')
        .select('*')
        .order('fecha_inicio_programada', { ascending: true, nullsFirst: false })

      if (error) throw new Error(mensajeDeError(error))

      return (data ?? []) as unknown as FilaCronograma[]
    },
  })

  return {
    filas: consulta.data ?? [],
    cargando: consulta.isLoading,
    error: consulta.error?.message ?? null,
  }
}
